import { YandexAuthData } from '../../../src/shared/api/authApi.ts'
import { useMount } from '../../shared/lib/utils.ts'

interface YandexAuthButtonProps {
  onSuccessHandler: (data: YandexAuthData) => void
  onErrorHandler?: () => void
  className?: string
  redirect_uri?: string
  width?: string
  buttonView?: 'main' | 'icon'
}

export const YA_CHANNEL_NAME = 'yandexOAuthChannel'

const DEF_REDIRECT_URI = import.meta.env.VITE_YANDEX_DEF_URI
const TOKEN_PAGE_ORIGIN = import.meta.env.VITE_YANDEX_PAGE_ORIGIN

const oauthQueryParams = {
  client_id: import.meta.env.VITE_YANDEX_CLIENT_ID,
  response_type: 'token',
}

const suggestParamsObj = {
  view: 'button',
  parentId: 'ya-batton',
  buttonSize: 'l',
  buttonTheme: 'light',
  buttonIcon: 'ya',
  buttonBorderRadius: 24,
  buttonView: 'main',
}

export const YandexAuthButton = (props: YandexAuthButtonProps) => {
  useMount(() => {
    const queryParams = {
      ...oauthQueryParams,
      redirect_uri: props.redirect_uri ?? DEF_REDIRECT_URI,
    }
    const suggestParams = {
      ...suggestParamsObj,
      ...(props.buttonView === 'icon'
        ? {
            buttonView: 'icon',
            buttonSize: 'xxl',
          }
        : {}),
    }

    const channel = new BroadcastChannel(YA_CHANNEL_NAME)
    channel.onmessage = (event: MessageEvent) => {
      props.onSuccessHandler({ token: event.data as string })
    }
    window.YaAuthSuggest.init(queryParams, TOKEN_PAGE_ORIGIN, suggestParams)
      .then((result) => {
        if (result.status === 'ok') {
          return result.handler()
        } else {
          throw new Error(`YandexAuth error: ${result.code}`)
        }
      })
      .catch((error) => {
        console.error('YandexAuth init error: ', error)
      })

    return () => {
      channel.close()
    }
  })

  return (
    <div
      id="ya-batton"
      className={props.className}
      style={{
        height: '48px',
        width: props.width ?? '104px',
        borderRadius: '24px',
        backgroundColor: 'red',
      }}
    />
  )
}
